<template>
  <v-container fluid>
    <!-- 一覧部 -->
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading" :visibleStore="false">
          <template v-slot:button>
            <v-btn class="mr-2" depressed small color="success" @click.stop="showRefineDialog" :disabled="false">絞込み</v-btn>
          </template>
          <template v-slot:action="{ item }">
             <div v-if="(item.holiday_flg)">
              <v-btn class="mr-2" depressed small color="error" @click.stop="showholidayDeleteDialog(item.worker_date)">削除</v-btn>
            </div>
            <div v-else>
              <v-btn v-if="updatePermission" class="mr-2" depressed small color="primary" @click.stop="showEditDialog(item.id)">編集</v-btn>
            </div>
          </template>
        </custom-data-table>
      </v-col>
    </v-row>
    <!-- 絞込みダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="refineDialogDrawer" persistent max-width="500">
        <v-card>
          <v-container>
            <v-card-title class="headline">絞り込み</v-card-title>
            <v-card-text>
              <v-form ref="refine_dialog_form" v-model="refineDialogValid" @submit.prevent>
                <!-- 開始日付、終了日付 -->
                <v-row>
                  <v-col cols="12" md="5">
                    <v-menu min-width="290px" max-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" label="開始日付" v-model="startFormatted" dense outlined readonly @blur="start_date = parseDate(startFormatted)">
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="start_date" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-menu min-width="290px" max-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" label="終了日付" v-model="endFormatted" dense outlined readonly @blur="end_date = parseDate(endFormatted)">
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="end_date" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
                    </v-menu>
                  </v-col>
                </v-row>
                <!-- 工番 -->
                <v-row>
                  <v-col cols="12" md="10">
                    <v-select label="工番" v-model="construction" :items="construction_list" item-text="name" item-value="value" no-data-text="データがありません" dense outlined return-object>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(1)">クリア</v-btn>
                  </v-col>
                </v-row>
                <!-- 部署 -->
                <v-row>
                  <v-col cols="12" md="10">
                    <v-select label="部署" v-model="department" :items="department_list" item-text="name" item-value="value" no-data-text="データがありません" dense outlined return-object>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(2)">クリア</v-btn>
                  </v-col>
                </v-row>
                <!-- 監督者 -->
                <v-row>
                  <v-col cols="12" md="10">
                    <v-select label="監督者" v-model="management_user" :items="management_user_list" item-text="name" item-value="value" no-data-text="データがありません" dense outlined return-object>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(3)">クリア</v-btn>
                  </v-col>
                </v-row>
                <!-- 作業者 -->
                <v-row>
                  <v-col cols="12" md="10">
                    <v-select label="作業者" v-model="worker_user" :items="worker_user_list" item-text="name" item-value="value" no-data-text="データがありません" dense outlined return-object>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn class="mt-1" depressed small color="error" @click.stop="clearRefineField(4)">クリア</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed color="grey lighten-1" @click.stop="hideRefineDialog">キャンセル</v-btn>
              <v-btn depressed color="success" @click.stop="execRefine" :disabled="!refineDialogValid">絞込み</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- 作業時間入力ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="editDialogDrawer" persistent max-width="500">
        <v-card>
          <v-container>
            <v-card-title class="headline">作業時間入力</v-card-title>
            <v-card-text>
              <v-form ref="edit_dialog_form" v-model="editDialogValid" @submit.prevent>
                <!-- 作業時間（開始・終了） -->
                <v-row>
                  <v-col cols="12" md="4"><header class="mt-2">作業時間</header></v-col>
                  <v-col cols="12" md="4">
                    <v-menu ref="startWorkerMenu" v-model="startWorkerTimeMenu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="startWorkerTime"
                      transition="scale-transition" offset-y max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field label="作業開始時間" v-model="startWorkerTime" dense outlined readonly v-on="on"/>
                      </template>
                      <v-time-picker v-if="startWorkerTimeMenu" v-model="startWorkerTime" format="24hr" :max="endWorkerTime" full-width @click:minute="$refs.startWorkerMenu.save(startWorkerTime)"/>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-menu ref="endWorkerMenu" v-model="endWorkerTimeMenu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="endWorkerTime"
                      transition="scale-transition" offset-y max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field label="作業終了時間" v-model="endWorkerTime" dense outlined readonly v-on="on"/>
                      </template>
                      <v-time-picker v-if="endWorkerTimeMenu" v-model="endWorkerTime" format="24hr" :min="startWorkerTime" full-width @click:minute="$refs.endWorkerMenu.save(endWorkerTime)"/>
                    </v-menu>
                  </v-col>
                </v-row>
                <!-- 休憩時間 -->
                <v-row>
                  <v-col cols="12" md="4"><header class="mt-2">休憩時間</header></v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="休憩(時間)" suffix="時間" v-model="workerBreakHourTime" :rules="workerBreakHourTimeRules" dense outlined/>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="休憩(分)" suffix="分" v-model="workerBreakMinuteTime" :rules="workerBreakMinuteTimeRules" dense outlined/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-btn depressed small color="blue" text-color="white" @click.stop="clearEditField">残業時間をクリア</v-btn>
                  </v-col>
                </v-row>
                <!-- 残業時間（開始・終了） -->
                <v-row>
                  <v-col cols="12" md="4"><header class="mt-2">残業時間</header></v-col>
                  <v-col cols="12" md="4">
                    <v-menu ref="startOverMenu" v-model="startOverTimeMenu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="startOverTime"
                      transition="scale-transition" offset-y max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field label="残業開始時間" v-model="startOverTime" dense outlined readonly v-on="on"/>
                      </template>
                      <v-time-picker v-if="startOverTimeMenu" v-model="startOverTime" format="24hr" :max="endOverTime" full-width @click:minute="$refs.startOverMenu.save(startOverTime)"/>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-menu ref="endOverMenu" v-model="endOverTimeMenu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="endOverTime"
                      transition="scale-transition" offset-y max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field label="残業終了時間" v-model="endOverTime" dense outlined readonly v-on="on"/>
                      </template>
                      <v-time-picker v-if="endOverTimeMenu" v-model="endOverTime" format="24hr" :min="startOverTime" full-width @click:minute="$refs.endOverMenu.save(endOverTime)"/>
                    </v-menu>
                  </v-col>
                </v-row>
                <!-- 残業休憩時間 -->
                <v-row>
                  <v-col cols="12" md="4"><header class="mt-2">残業休憩時間</header></v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="休憩(時間)" suffix="時間" v-model="overBreakHourTime" :rules="overBreakHourTimeRules" dense outlined/>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="休憩(分)" suffix="分" v-model="overBreakMinuteTime" :rules="overBreakMinuteTimeRules" dense outlined/>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed color="grey lighten-1" @click.stop="editDialogDrawer=!editDialogDrawer">キャンセル</v-btn>
                <v-btn depressed color="success" @click.stop="execEdit" :disabled="!editDialogValid">更新</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- 休暇日削除ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="holidayDeleteDialogDrawer" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">休暇日削除</v-card-title>
            <v-card-text><h4>{{this.holiday_date}}の休暇日登録を削除しますか？</h4></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="holidayDeleteDialogDrawer = false">キャンセル</v-btn>
            <v-btn depressed color="error" @click.stop="deleteholiday()">削除</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import Rule from "@/validation/rules";
import WorkerDailyReportBulkApi from "@/api/worker-daily-report-bulk-api";
import CustomDataTable from "@/components/custom_ui/CustomDataTable";
import WorkerDailyReportApi from "@/api/worker-daily-report-api";

export default {
  name: "WorkerDailyReportBulk",
  components: {
    CustomDataTable,
  },
  props: ["user"],
  data: () => ({
    // --------------------------------
    // 共通コンポーネント: データテーブル関連
    // --------------------------------
    loading: false,
    tableName: "作業日報一括修正",
    headers: [
      { text: "日付", value: "worker_date"},
      { text: "工番", value: "construction_number_name"},
      { text: "部署", value: "department_name_section"},
      { text: "監督者", value: "management_user_name"},
      { text: "作業者", value: "worker_user_name"},
      { text: "作業時間", value: "work_time"},
      { text: "休憩時間", value: "work_break_time"},
      { text: "残業時間", value: "over_time"},
      { text: "残業休憩時間", value: "over_break_time"},
      { text: "アクション", value: "action"},
    ],
    items: [],
    // 編集権限
    updatePermission: false,
    holiday_date : "",
    // --------------------------------
    // 絞込みダイアログ
    // --------------------------------
    refineDialogDrawer: false,
    refineDialogValid: false,
    // 日付（開始・終了）
    start_date: '',
    startFormatted: '',
    end_date: '',
    endFormatted: '',
    // 工番
    construction: null,
    construction_list: [],
    // 部署
    department: null,
    department_list: [],
    // 監督者
    management_user: null,
    management_user_list: [],
    // 作業者
    worker_user: null,
    worker_user_list: [],
    // 退避用
    stackItems: {
      // 日付（開始・終了）
      start_date: '',
      startFormatted: '',
      end_date: '',
      endFormatted: '',
      // 工番
      construction: null,
      // 部署
      department: null,
      // 監督者
      management_user: null,
      // 作業者
      worker_user: null,
    },
    // --------------------------------
    // 編集ダイアログ（作業時間入力）
    // --------------------------------
    editDialogDrawer: false,
    editDialogValid: false,
    selectedItemsIndex: 0,
    // 作業開始時間
    startWorkerTime: null,
    startWorkerTimeMenu: false,
    // 作業終了時間
    endWorkerTime: null,
    endWorkerTimeMenu: false,
    // 作業休憩時間
    workerBreakHourTime: null,
    workerBreakMinuteTime: null,
    workerBreakHourTimeRules: Rule.breakHourTimeRules,
    workerBreakMinuteTimeRules: Rule.breakMinuteTimeRules,
    // 残業開始時間
    startOverTime: null,
    startOverTimeMenu: false,
    // 残業終了時間
    endOverTime: null,
    endOverTimeMenu: false,
    // 作業休憩時間
    overBreakHourTime: null,
    overBreakMinuteTime: null,
    overBreakHourTimeRules: Rule.breakHourTimeRules,
    overBreakMinuteTimeRules: Rule.breakMinuteTimeRules,
    // --------------------------------
    // 削除ダイアログ
    // --------------------------------
    holidayDeleteDialogDrawer: false
  }),
  created() {
    this.initialize();
  },
  watch: {
    'start_date': function(){
      if (this.end_date < this.start_date) {
          this.end_date = this.start_date;
      }
      this.startFormatted = this.formatDate(this.start_date);
    },
    'end_date': function(){
      if (this.start_date > this.end_date) {
          this.start_date = this.end_date;
      }
      this.endFormatted = this.formatDate(this.end_date);
    },
  },
  methods: {
    // -----------------------------------------------------
    // ローディングの表示/非表示処理
    // -----------------------------------------------------
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    // -----------------------------------------------------
    // 初期化処理
    // -----------------------------------------------------
    initialize() {
      this.isLoading();
      this.workerDailyReportBulkApi = new WorkerDailyReportBulkApi();
      // 権限
      if (this.user.role_id == 0) {
        this.updatePermission = this.user.permission_config.CTSG00018.update;
      }
      // 検索条件(必須)：検索開始日・終了日を初期セット（当月１日～当日）
      const now = new Date();
      this.start_date = now.getFullYear() + "-" + ("00" + (now.getMonth() + 1)).slice(-2) + "-" + "01";
      this.end_date = now.getFullYear() + "-" + ("00" + (now.getMonth() + 1)).slice(-2) + "-" + ("00" + (now.getDate())).slice(-2);
      // 検索条件(任意)：他の検索条件項目をセット
      const prm_construction = (this.construction == null) ? "0" : this.construction.value;
      const prm_department = (this.department == null) ? "0" : this.department.value;
      const prm_management_user = (this.management_user == null) ? "0" : this.management_user.value;
      const prm_worker_user = (this.worker_user == null) ? "0" : this.worker_user.value;
      // 一覧データ取得（API送信実行）
      const promise = this.workerDailyReportBulkApi.list(
        this.start_date,
        this.end_date,
        prm_construction,
        prm_department,
        prm_management_user,
        prm_worker_user
      );
      promise.then(response => {
        // 一覧表示リストを構築
        this.items = response.data.body.worker_daily_report_bulk_list;
        for (let item of this.items) {
          if (item.construction_number == null && item.construction_name == null){
            item.construction_number_name = '';
          } else {
            item.construction_number_name = item.construction_number + ' ' + item.construction_name;
          }
          item.department_name_section = item.department_name;
          if (item.department_section) {
            item.department_name_section += ' - ' + item.department_section;
          }
          if (item.holiday_flg){
            item.worker_user_name = "";
            item.work_time = "";
            item.work_break_time = "";
            item.over_time = "";
            item.over_break_time = "";
          } else {
            const workTime = this.calcWorkTime(item.start_worker_time, item.end_worker_time, item.worker_break_hour_time, item.worker_break_minute_time);
            item.work_time = this.formatDispTime(workTime.hour, workTime.minute);
            item.work_break_time = this.formatDispTime(item.worker_break_hour_time, item.worker_break_minute_time);
            const overTime = this.calcWorkTime(item.start_over_time, item.end_over_time, item.over_break_hour_time, item.over_break_minute_time);
            item.over_time = this.formatDispTime(overTime.hour, overTime.minute);
            item.over_break_time = this.formatDispTime(item.over_break_hour_time, item.over_break_minute_time);
          }
        }
        // 工番リストを構築（絞り込みダイアログ用）
        for (let item of response.data.body.construction_list) {
          this.construction_list.push({
            name: item.construction_number + ' ' + item.name,
            value: item.id
          });
        }
        // 部署リストを構築（絞り込みダイアログ用）
        for (let item of response.data.body.department_list) {
          let the_name = item.name;
          if (item.section) {
              the_name += " - " + item.section;
          }
          this.department_list.push({
            name: the_name,
            value: item.id
          });
        }
        // 監督者・作業者リストを構築（絞り込みダイアログ用）
        for (let item of response.data.body.user_list) {
          this.management_user_list.push({
            name: item.name,
            value: item.id
          });
          this.worker_user_list.push({
            name: item.name,
            value: item.id
          });
        }
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: "Dashboard" });
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    // -----------------------------------------------------
    // 絞込みボタン押下時（絞込みダイアログを表示する）
    // -----------------------------------------------------
    showRefineDialog() {
      // キャンセル用変数へ退避してダイアログ表示
      this.stackItems.start_date = this.start_date;
      this.stackItems.startFormatted = this.startFormatted;
      this.stackItems.end_date = this.end_date;
      this.stackItems.endFormatted = this.endFormatted;
      this.stackItems.construction = this.construction;
      this.stackItems.department = this.department;
      this.stackItems.management_user = this.management_user;
      this.stackItems.worker_user = this.worker_user;
      this.refineDialogDrawer = true;
    },
    // -----------------------------------------------------
    // 絞込みダイアログ：クリアボタン押下時（入力項目をクリアする）
    // -----------------------------------------------------
    clearRefineField(idx) {
      switch (idx) {
        case 1: // 工番
          this.construction = null;
          break;
        case 2: // 部署
          this.department = null;
          break;
        case 3: // 管理者
          this.management_user = null;
          break;
        case 4: // 作業者
          this.worker_user = null;
          break;
      }
    },
    // -----------------------------------------------------
    // 絞込みダイアログ：キャンセルボタン押下時（絞込みダイアログを非表示する）
    // -----------------------------------------------------
    hideRefineDialog() {
      // キャンセル用変数から復元してダイアログ非表示
      this.start_date = this.stackItems.start_date;
      this.startFormatted = this.stackItems.startFormatted;
      this.end_date = this.stackItems.end_date;
      this.endFormatted = this.stackItems.endFormatted;
      this.construction = this.stackItems.construction;
      this.department = this.stackItems.department;
      this.management_user = this.stackItems.management_user;
      this.worker_user = this.stackItems.worker_user;
      this.refineDialogDrawer = false;
    },
    // -----------------------------------------------------
    // 絞込みダイアログ：絞込みボタン押下時（表示リストを再構築する）
    // -----------------------------------------------------
    execRefine() {
      // ダイアログを非表示
      this.refineDialogDrawer = false;
      const prm_construction = (this.construction == null) ? "0" : this.construction.value;
      const prm_department = (this.department == null) ? "0" : this.department.value;
      const prm_management_user = (this.management_user == null) ? "0" : this.management_user.value;
      const prm_worker_user = (this.worker_user == null) ? "0" : this.worker_user.value;
      // 一覧データ取得（API送信実行）
      const promise = this.workerDailyReportBulkApi.list(
        this.start_date,
        this.end_date,
        prm_construction,
        prm_department,
        prm_management_user,
        prm_worker_user
      );
      this.isLoading();
      promise.then(response => {
        // 一覧表示リストを構築
        this.items = response.data.body.worker_daily_report_bulk_list;
        for (let item of this.items) {
          if (item.construction_number == null && item.construction_name == null){
            item.construction_number_name = '';
          } else {
            item.construction_number_name = item.construction_number + ' ' + item.construction_name;
          }
          item.department_name_section = item.department_name;
          if (item.department_section) {
            item.department_name_section += ' - ' + item.department_section;
          }
          if(item.holiday_flg){
            item.work_time = "";
            item.work_break_time = "";
            item.over_time = "";
            item.over_break_time = "";
          }else{
            const workTime = this.calcWorkTime(item.start_worker_time, item.end_worker_time, item.worker_break_hour_time, item.worker_break_minute_time);
            item.work_time = this.formatDispTime(workTime.hour, workTime.minute);
            item.work_break_time = this.formatDispTime(item.worker_break_hour_time, item.worker_break_minute_time);
            const overTime = this.calcWorkTime(item.start_over_time, item.end_over_time, item.over_break_hour_time, item.over_break_minute_time);
            item.over_time = this.formatDispTime(overTime.hour, overTime.minute);
            item.over_break_time = this.formatDispTime(item.over_break_hour_time, item.over_break_minute_time);
          }
        }
        // 工番リストを構築（絞り込みダイアログ用）
        this.construction_list = [];
        for (let item of response.data.body.construction_list) {
          this.construction_list.push({
            name: item.construction_number + ' ' + item.name, value: item.id
          });
        }
        // 部署リストを構築（絞り込みダイアログ用）
        this.department_list = [];
        for (let item of response.data.body.department_list) {
          this.department_list.push({
            name: item.name + ' - ' + item.section, value: item.id
          });
        }
        // 監督者・作業者リストを構築（絞り込みダイアログ用）
        this.management_user_list = [];
        this.worker_user_list = [];
        for (let item of response.data.body.user_list) {
          this.management_user_list.push({
            name: item.name, value: item.id
          });
          this.worker_user_list.push({
            name: item.name, value: item.id
          });
        }
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: "Dashboard" })
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    // -----------------------------------------------------
    // 編集ボタン押下時処理（編集ダイアログを表示する）
    // -----------------------------------------------------
    showEditDialog(id) {
      // 選択行のデータを決定
      let selitem = null;
      let idx = 0;
      for (let item of this.items) {
        if (item.id === id) {
          this.selectedItemsIndex = idx;
          selitem = item;
          break;
        }
        idx++;
      }
      if (selitem) {
        // 作業時間・作業休憩時間をセット
        this.startWorkerTime = selitem.start_worker_time;
        this.endWorkerTime = selitem.end_worker_time;
        this.workerBreakHourTime = selitem.worker_break_hour_time;
        this.workerBreakMinuteTime = selitem.worker_break_minute_time;
        // 残業時間・残業休憩時間をセット
        this.startOverTime = selitem.start_over_time;
        this.endOverTime = selitem.end_over_time;
        this.overBreakHourTime = selitem.over_break_hour_time;
        this.overBreakMinuteTime = selitem.over_break_minute_time;
      }
      // 編集ダイアログを表示
      this.editDialogDrawer = true;
    },
    // -----------------------------------------------------
    // 編集ダイアログ：残業時間をクリアボタン押下時（入力項目をクリアする）
    // -----------------------------------------------------
    clearEditField() {
      this.startOverTime = null;
      this.endOverTime = null;
      this.overBreakHourTime = null;
      this.overBreakMinuteTime = null;
    },
    // -----------------------------------------------------
    // 編集ダイアログ：編集ボタン押下時処理（作業日報をDB更新）
    // -----------------------------------------------------
    execEdit() {
      const idx = this.selectedItemsIndex;
      // 入力値を反映
      let upditem = this.items[idx];
      upditem.start_worker_time = this.startWorkerTime;
      upditem.end_worker_time = this.endWorkerTime;
      upditem.worker_break_hour_time = this.workerBreakHourTime;
      upditem.worker_break_minute_time = this.workerBreakMinuteTime;
      upditem.start_over_time = this.startOverTime;
      upditem.end_over_time = this.endOverTime;
      upditem.over_break_hour_time = this.overBreakHourTime;
      upditem.over_break_minute_time = this.overBreakMinuteTime;
      // 再計算して表示項目へ反映
      const workTime = this.calcWorkTime(upditem.start_worker_time, upditem.end_worker_time, upditem.worker_break_hour_time, upditem.worker_break_minute_time);
      upditem.work_time = this.formatDispTime(workTime.hour, workTime.minute);
      const overTime = this.calcWorkTime(upditem.start_over_time, upditem.end_over_time, upditem.over_break_hour_time, upditem.over_break_minute_time);
      upditem.over_time = this.formatDispTime(overTime.hour, overTime.minute);
      upditem.work_break_time = this.formatDispTime(upditem.worker_break_hour_time, upditem.worker_break_minute_time);
      upditem.over_break_time = this.formatDispTime(upditem.over_break_hour_time, upditem.over_break_minute_time);
      this.items.splice(idx, 1, upditem);
      this.editDialogDrawer = false;
      // DBへ反映（API送信実行）
      const prmOverTime = (overTime.hour === 0 && overTime.minute === 0) ? null : overTime;
      const params = {
        startWorkerTime: this.startWorkerTime,
        endWorkerTime: this.endWorkerTime,
        workerBreakHourTime: this.workerBreakHourTime,
        workerBreakMinuteTime: this.workerBreakMinuteTime,
        startOverTime: this.startOverTime,
        endOverTime: this.endOverTime,
        overBreakHourTime: this.overBreakHourTime,
        overBreakMinuteTime: this.overBreakMinuteTime,
        workerTime: workTime,
        overTime: prmOverTime
      };
      const promise = this.workerDailyReportBulkApi.update(upditem.id, params);
      this.isLoading();
      promise.then(response => {
        this.$emit("success", response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
        // 後処理：選択値をクリア
        this.startWorkerTime = null;
        this.endWorkerTime = null;
        this.workerBreakHourTime = null;
        this.workerBreakMinuteTime = null;
        this.startOverTime = null;
        this.endOverTime = null;
        this.overBreakHourTime = null;
        this.overBreakMinuteTime = null;
      });
    },
    // -----------------------------------------------------
    // 日付フォーマット（ハイフン区切りをスラッシュ区切りyyyy/mm/dd形式の日付に変換）
    // -----------------------------------------------------
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}/${month}/${day}`;
    },
    // -----------------------------------------------------
    // 日付フォーマット（スラッシュ区切りをハイフン区切りyyyy-mm-dd形式の日付に変換）
    // -----------------------------------------------------
    parseDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    // -----------------------------------------------------
    // 時刻計算
    // -----------------------------------------------------
    calcWorkTime(startTime, endTime, breakHourTime, breakMinuteTime) {
      // 開始時刻
      var startTimeSplit = [];
      var startTimeHour = 0;
      var startTimeMinute = 0;
      if (startTime != null && startTime != undefined) {
        startTimeSplit = startTime.split(':');
      }
      if (startTimeSplit.length > 0) {
        startTimeHour = parseInt(startTimeSplit[0]);
        if (0 < parseInt(startTimeSplit[1])) {
          startTimeHour = startTimeHour + 1;
          startTimeMinute = 60 - parseInt(startTimeSplit[1]);
        }
      }
      // 終了時刻
      var endTimeSplit = [];
      var endTimeHour = 0;
      var endTimeMinute = 0;
      if (endTime != null && endTime != undefined) {
        endTimeSplit = endTime.split(':');
      }
      if (endTimeSplit.length > 0) {
        endTimeHour = parseInt(endTimeSplit[0]);
        endTimeMinute = parseInt(endTimeSplit[1]);
      }
      // 計算
      var hour = 0;
      if (startTimeHour < endTimeHour) {
        hour = endTimeHour - startTimeHour
        if (breakHourTime != null) {
          hour = hour - breakHourTime;
        }
      }
      var minute = 0;
      var temp = (startTimeMinute + endTimeMinute);
      if (breakMinuteTime != null) {
        if (temp < breakMinuteTime) {
          hour = hour - 1;
          temp = 60 - (breakMinuteTime - temp);
        } else {
          temp = temp - breakMinuteTime;
        }
      }
      if (60 < temp) {
        hour = hour + 1;
        minute = 60 - temp;
      } else {
        minute = temp;
      }
      return { hour: hour, minute: minute };
    },
    // -----------------------------------------------------
    // 表示時間フォーマット
    // -----------------------------------------------------
    formatDispTime(hour, minute) {
      let retStr = '';
      if (hour > 0) {
        retStr = hour + '時間';
      }
      if (minute > 0) {
        retStr += minute + '分';
      }
      if (!retStr) {
        retStr = '0分';
      }
      return retStr;
    },
    // 休暇日削除ボタン押下時
    showholidayDeleteDialog(date) {
      this.holiday_date = date;
      this.holidayDeleteDialogDrawer = true;
    },
    deleteholiday() {
      this.isLoading();
      this.workerDailyReportApi = new WorkerDailyReportApi();
      const promise = this.workerDailyReportApi.delete(this.holiday_date);
      promise.then(response => {
        this.holidayDeleteDialogDrawer = false;
        this.$emit('success', response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error",error.response.data.message);
            this.$router.push({ name: "Dashboard" })
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
        this.initialize();
      });
    },
  }
};
</script>
